module.exports = __webpack_public_path__ + "img/correct.bd9ac242.png";